<script>
import ModelCreate from "../models/create";
import FormsModel from "@/components/forms/service";

export default {
  extends: ModelCreate,
  page: {
    title: "Create Service",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('services.singular')) }},
    resourceRoute: {default: 'services'},
    modelVariable: {default: 'service'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t('services.plural')),
      items: [
        {
          text: this.lodash.startCase(this.$t('services.plural')),
          href: "/services",
        },
        {
          text: this.$t("Create New"),
          href: "/services/create",
          active: true,
        },
      ]
    }
  },
  methods: {
    store(value) {
      const body = {...value}
      body.is_beta = true;
      body.customer_type = value.customer_type.join(',');
      return this.$axios.post('/shrimps', body);
    }
  }
}
</script>
